export default "<app-wo-stopped-list [orderStatus]=\"'SU'\" [allowRecover]=\"true\"></app-wo-stopped-list>"